import ReactGA from 'react-ga';
import React, {Component} from 'react';
import { withRouter } from 'react-router-dom';

class Layout extends Component {
    constructor(props) {
        super(props)
    }

    componentDidMount() {
        ReactGA.initialize('UA-133949946-1');
        ReactGA.pageview(document.location.pathname)
    }

    shouldComponentUpdate(prevProps) {
        if(prevProps.location.pathname !== this.props.location.pathname) {
            ReactGA.pageview(prevProps.location.pathname);
            return true;
        }
        return false;
    }
    
    render() {
        return (
            <div className="layout" style={{paddingTop: '4em'}}>
                {this.props.children}
            </div>
        )
    }
}

export default withRouter(props => <Layout {...props}/>);


// WEBPACK FOOTER //
// ./src/components/Layout.js